export const FormsAssistant = {
    "Forms": {
        items: [
            //Changing system UI
            {
                heading: 'Creating a form template',
                permissions: ['System Admin'],
                tags: ['forms', 'create'],
                sections: [
                    {
                        description: 'Navigate to the forms builder',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the forms builder',
                        action: {
                            type: 'location',
                            value: '/sys-admin/form/builder',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Approving a questionnaire template
            {
                heading: 'Approving a form template',
                permissions: ['System Admin'],
                tags: ['form', 'aprrov'],
                sections: [
                    {
                        description: 'Navigate to the form builder',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the <b>Awaiting Approval</b> tab',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the item to approve',
                        styleAs: 'list',
                    },
                    {
                        description: 'Review the item',
                        styleAs: 'note',
                    },
                    {
                        description: 'Select approve from the toast on the top left of the screen',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the form builder',
                        action: {
                            type: 'location',
                            value: '/sys-admin/form/builder',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}